import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: environment.environment,
  release: environment.release,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled:true,
});
bootstrapApplication(App, appConfig).catch((err) => console.error(err));

